/**
 * This class is auto generated by using the
 * "Dots.KLASIS.TsGenerator".
 * */
export const classifierList = {

    facet: {
        all: `Visi`,
        area: `Lietošanas joma`,
        author: `Izstrādātājs`,
        authority: `Atbildīgā institūcija`,
        availability: `Pieejamība`,
        extraField1: `Papildlauks 1`,
        extraField2: `Papildlauks 2`,
        extraField3: `Papildlauks 3`,
        extraField4: `Papildlauks 4`,
        publicationYear: `Izdošanas gads`,
        region: `Klasifikācijas statuss`,
    },
    sortOrder: {
        ascending: `A \u2192 Z`,
        descending: `Z \u2192 A`,
        mostPopular: `Populārākie`,
    },
}
